import React from 'react';
import TwField, { TwInputTypes } from '../../../components/TwFields/TwFields';
import CloseIcon from '@mui/icons-material/Close';
import './InvoiceItems.scss';
import TwAutocomplete, {
  TwAutocompleteOption
} from '../../../components/TwAutocomplete/TwAutocomplete';

export interface RateItem {
  description: string;
  amount: number;
  product?: TwAutocompleteOption | null;
}

interface RateItemsProps {
  isQbo: boolean;
  invoiceItem: RateItem;
  onAutocompleteChange: (
    e: React.SyntheticEvent<Element, Event>,
    value: TwAutocompleteOption | null
  ) => void;
  onInputChange: (
    e: React.ChangeEvent<HTMLInputElement> | React.ChangeEvent<HTMLTextAreaElement>
  ) => void;
  index: number;
  remove?: <T>(index: number) => T | undefined;
  qboServices: TwAutocompleteOption[];
}

const InvoiceItems: React.FC<RateItemsProps> = ({
  invoiceItem,
  onInputChange,
  onAutocompleteChange,
  index,
  remove,
  isQbo,
  qboServices
}) => {
  return (
    <>
      {!isQbo ? (
        <div className="invoice-items__wrapper">
          <div className="invoice-items__description">
            <TwField
              name={`invoiceItems[${index}].description`}
              inputType={TwInputTypes.text}
              error={false}
              fullWidth={true}
              autoComplete="off"
              value={invoiceItem.description}
              onInputChange={onInputChange}
              disabled={false}
            />
          </div>
          <div className="invoice-items__amount">
            <TwField
              name={`invoiceItems[${index}].amount`}
              inputType={TwInputTypes.number}
              error={false}
              fullWidth={true}
              autoComplete="off"
              startAdorment={<span className="invoice-items__amount-adornment">$ </span>}
              value={invoiceItem.amount}
              onInputChange={onInputChange}
            />
          </div>
          {index > 0 && (
            <CloseIcon
              className="invoice-items__remove"
              onClick={(): void => remove && remove(index)}
            />
          )}
        </div>
      ) : (
        <div className="invoice-items__qbo-wrapper">
          <div className="invoice-items__row">
            <div className="invoice-items__qbo-product">
              <TwAutocomplete
                name={`invoiceItems[${index}].product`}
                optionList={qboServices}
                value={invoiceItem.product}
                onChange={onAutocompleteChange}
                placeholder="Product or service"
              />
            </div>

            <div className="invoice-items__amount">
              <TwField
                name={`invoiceItems[${index}].amount`}
                inputType={TwInputTypes.number}
                error={false}
                fullWidth={true}
                autoComplete="off"
                startAdorment={<span className="invoice-items__amount-adornment">$ </span>}
                value={invoiceItem.amount}
                onInputChange={onInputChange}
              />
            </div>
            {index > 0 && (
              <CloseIcon
                className="invoice-items__remove"
                onClick={(): void => remove && remove(index)}
              />
            )}
          </div>
          <div className="invoice-items__qbo-description">
            <TwField
              name={`invoiceItems[${index}].description`}
              inputType={TwInputTypes.textarea}
              error={false}
              fullWidth={true}
              autoComplete="off"
              placeholder="Description"
              value={invoiceItem.description}
              onInputChange={onInputChange}
              disabled={false}
            />
          </div>
        </div>
      )}
    </>
  );
};

export default InvoiceItems;
